import { useMutation } from "@apollo/client";
import { ResendInviteToShareGoalMutation, ResendInviteToShareGoalMutationVariables } from "@ctypes";
import { RESEND_INVITE_TO_SHARE_GOAL } from "@graphql";

export const useResendInviteToShareGoal = () => {
  return useMutation<ResendInviteToShareGoalMutation, ResendInviteToShareGoalMutationVariables>(
    RESEND_INVITE_TO_SHARE_GOAL,
  );
};
